import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import ItemList from 'flarum/common/utils/ItemList';
import listItems from 'flarum/common/helpers/listItems';
import Avatar from 'flarum/common/components/Avatar';
import Link from 'flarum/common/components/Link';

// `bio()` is provided by the optional fof/user-bio extension and is not part of
// core's User typings, so we declare it as an optional augmentation here.

export default class BlogAuthor extends Component {
  view(vnode) {
    const author = !this.attrs.loading ? this.attrs.article ? this.attrs.article.user() || null : this.attrs.user : null;
    return m("div", {
      className: 'FoFBlog-Article-Author'
    }, m("div", {
      className: "FoFBlog-Article-Author-background ".concat(this.attrs.loading ? 'FoFBlog-Author-Ghost' : ''),
      style: {
        backgroundColor: author && author.color() ? author.color() : null
      }
    }), m("div", {
      className: 'FoFBlog-Article-Author-Avatar'
    }, author ? m(Link, {
      href: app.route('user', {
        username: author.username()
      })
    }, m(Avatar, {
      user: author
    })) : m("span", {
      className: 'Avatar FoFBlog-Author-Ghost'
    })), author && m("div", {
      className: 'FoFBlog-Article-Author-Info'
    }, m(Link, {
      href: app.route('user', {
        username: author.username()
      }),
      className: 'FoFBlog-Article-Author-Name'
    }, author.displayName()), m("p", {
      className: 'FoFBlog-Article-Author-Bio'
    }, author.bio && author.bio()), m("ul", {
      className: 'FoFBlog-Article-Author-Extended'
    }, listItems(this.items().toArray()))), this.attrs.loading && m("div", null, m("span", {
      className: 'FoFBlog-Article-Author-Name FoFBlog-Author-Ghost'
    }, "\xA0"), m("p", {
      className: 'FoFBlog-Article-Author-Bio FoFBlog-Author-Ghost'
    }, "\xA0"), m("p", {
      className: 'FoFBlog-Article-Author-Bio FoFBlog-Author-Ghost'
    }, "\xA0"), m("p", {
      className: 'FoFBlog-Article-Author-Bio FoFBlog-Author-Ghost'
    }, "\xA0")));
  }
  items() {
    return new ItemList();
  }
}
flarum.reg.add('fof-blog', 'forum/components/BlogItemSidebar/BlogAuthor', BlogAuthor);